import React from 'react'

import type { TooltipProps } from 'antd'
import { Tooltip as AntTooltip } from 'antd'

export const Tooltip: React.FC<TooltipProps> = (props) => (
  <AntTooltip {...props} />
)
